import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { id: "tracks", label: "Tracks" },
  { id: "mosh", label: "Mosh Team" },
  { id: "shows", label: "Shows" },
  { id: "media", label: "Media" },
  { id: "merch", label: "Merch" },
  { id: "about", label: "About" },
  { id: "booking", label: "Booking" },
  { id: "crew", label: "Crew" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="nav-bar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-black/80 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="font-display font-black text-lg tracking-[0.3em] text-cream-soft hover:text-glow-magenta transition-all"
        >
          C<span className="text-[#FF00E5]">.</span>A<span className="text-[#00F0FF]">.</span>F<span className="text-[#FF00E5]">.</span>
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="font-mono-display text-[11px] uppercase tracking-[0.25em] text-white/70 hover:text-[#00F0FF] hover:text-glow-cyan transition-all"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-cream-soft p-2"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-panel" className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/10">
          <div className="flex flex-col px-6 py-5 gap-4">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left font-mono-display text-xs uppercase tracking-[0.25em] text-white/75 hover:text-[#FF00E5] py-2 border-b border-white/5"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
